// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"1974a44e","126":"1f7c9a4f","191":"334828e0","453":"3f6c78ed","784":"5bf261ca","947":"2a012f75"}[chunkId] + ".chunk.js";
};